/* eslint-disable camelcase */
import _ from 'underscore';
import queryString from 'query-string';
import stringify from 'json-stable-stringify';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
  FetchPolicy
} from '@bingads-webui-react/overreact';
import { getDefaultHeaderObj } from '@bingads-webui/overreact-bingads';

import { schema } from '../../../environment/schema';

function odataUrlFactory(params) {
  const { variables } = params;

  const { locator } = variables;
  const { descriptor } = locator;
  const {
    customer_id,
    account_id,
    campaign_id,
  } = descriptor;

  const initialSearch = _.omit(variables, 'locator');
  const searchString = _.isEmpty(initialSearch) ? '' : `?${queryString.stringify(initialSearch)}`;

  return `/Customers(${Number(customer_id)})/Accounts(${Number(account_id)})/Campaigns(${Number(campaign_id)})/Recommendation.GetESCBudgetLandscape${searchString}`;
}

function odataHeaderFactory() {
  return getDefaultHeaderObj();
}

export const fetchRequestContract = createRequestContract({
  schema,
  dataPath: 'customer:account:campaign:use_esc_budget_landscape',
  verb: requestVerbs.GET,
  fetchPolicy: FetchPolicy.NetworkOnly,
  uriFactoryFn: odataUrlFactory,
  headerFactoryFn: odataHeaderFactory,
  keySelector: variables => stringify(variables),
  parentKeySelector: variables => variables.locator.descriptor.campaign_id,
});

export const fetchResponseContract = createResponseContract({
  requestContract: fetchRequestContract,
  responseType: responseTypes.ENTITY,
  keySelector: r => stringify(r),
  processorFn: r => r,
});
